import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import termImage from "../Assets/termsIcon.png";
import avatarImage from "../Assets/profilePhoto.jpg";
import aboutImage from "../Assets/aboutIcon.png";
import certImage from "../Assets/certificateIcon.png";
import withdrawImage from "../Assets/whithdrawIcon.png";
import checkinImage from "../Assets/checkInIcon.png";
import faqImage from "../Assets/faqIcon.png";
import eventImage from "../Assets/eventIcon.png";
import Footer from "../Components/Footer";
import copyImage from "../Assets/copyIcon.png";
import contactImage from "../Assets/contactIcon.png";
import home from "../Api/home";
import profile from '../Api/profile';
import Swal from "sweetalert2";
import Logo from "../Assets/logo.png";
import Copyright_Footer from "../Components/copyrightFooter";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import terms from "../Api/terms";
import Model from "../Components/ModelParagraph";
import ModelContact from "../Components/ModelContactUs";
import aboutUs from "../Api/aboutUs";
import ModelSlider from "../Components/ModelSilder";
import cert from "../Api/cert";
import event from "../Api/event";
import ModelFAQ from "../Components/ModelFAQ";

export default function Home() {
  const [dashboardData, setDashboardData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showSliderModal, setShowSliderModal] = useState(false);
  const [showFAQModal, setShowFAQModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);


  const openFAQModal = () => {
    setShowFAQModal(true);
  };

  const closeFAQModal  = () => {
    setShowFAQModal(false);
  };

  const openSliderModal = (content) => {
    setShowSliderModal(true);
    setModalContent(content);
  };

  const closeSliderModal = () => {
    setShowSliderModal(false);
    setModalContent(null);
  };


  const openContactModal = (content) => {
    setShowContactModal(true);
    setModalContent(content);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
    setModalContent(null);
  };

  const openModal = (content) => {
    setShowModal(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const navigate = useNavigate();
  const handleToTerms = () => {
    fetchTermInfo();
  };
  const handleToAboutUs = () => {
    fetchAboutDataInfo();
  };
  const handleToContactUs = () => {
    openContactModal({ title: "Let's Join Us Now", content: 'If user has any enquiry, kindly contact the\n' + 'support service.' });
  };
  const handleToCertificate = () => {
    fetchCertDataInfo();
  };
  const handleToWithdraw = () => {
    openContactModal({ title: "Withdrawal Assistance", content: 'If you decide to withdraw, kindly contact the support service.' });
  };

  const handleToFaqs = () => {
    openFAQModal()
  };
  const handelToEvent = () => {
    fetchEventDataInfo();
  };

  const handelToCheckIn = () => {
    navigate("/check_in");
  };

  const handelToLevelDetails = () => {
    navigate("/levels");
  };

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  useEffect(() => {
    const fetchDashboardInfo = async () => {
      try {
        const response = await home();
        setDashboardData(response.data);
      } catch (error) {
        console.error("API Error:", error.message);
        if (error.response.status === 401 || error.response.status === 500 || error.response.status === 500) {
          Toast.fire({
            icon: 'error',
            title: error.response.data.title
          })
          localStorage.clear();
          navigate("/");
        }
        Toast.fire({
          icon: 'error',
          title: error.response.data.message
        })
      }
    };
    const fetchUserInfo = async () => {
      try {
        const response = await profile();
        setUserData(response.data);
      } catch (error) {
        console.error("API Error:", error.message);
      }
    };
    fetchDashboardInfo();
    fetchUserInfo()
  }, []);

  const handleCopyClick = () => {
    if (userData.referralCode) {
      navigator.clipboard.writeText(userData?.referralCode)
        .then(() => {
          console.log('Code snippet copied to clipboard!');
          // You can show a success message or perform any other desired action here
        })
        .catch((error) => {
          console.error('Failed to copy code snippet: ', error);
          // You can show an error message or handle the error in an appropriate way here
        });
    }
  };

  const fetchTermInfo = async () => {
    try {
      const response = await terms();
      openModal({ title: "Terms & Conditions", content: response.data?.data });
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response.status === 401 || error.response.status === 500) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  const fetchAboutDataInfo = async () => {
    try {
      const response = await aboutUs();
      openModal({ title: "About Us", content: response?.data });
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response.status === 401 || error.response.status === 500) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };


    const fetchCertDataInfo = async () => {
      try {
        const response = await cert();
        openSliderModal({ title: "Certificate", content: response?.data?.data });
      } catch (error) {
        console.error("API Error:", error.message);
        if (error.response.status === 401 || error.response.status === 500) {
          Toast.fire({
            icon: 'error',
            title: error.response.data.title
          })
          localStorage.clear();
          navigate("/");
        }
        Toast.fire({
          icon: 'error',
          title: error.response.data.message
        })
      }
    };

  const fetchEventDataInfo = async () => {
    try {
      const response = await event();
      openSliderModal({ title: "Latest Events", content: response?.data?.data });
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response.status === 401 || error.response.status === 500) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  return (
    <>
      <div className="container mobile-page mt-8">
        <div className="row">
          <div className="col-12">
            <img src={Logo} alt="Logo" className='my-3' width={150}/>
            <div className="profile-image">
              <img src={userData?.profilePicture ? userData?.profilePicture : avatarImage} alt="User Profile" className='border border-3 text-white' />
            </div>
          </div>
          <div className="col-7 mt-3">
            <p className="text-white h5">Active Total Balance</p>
            <p className="fontsize-25 text-white fw-bold">USDT {dashboardData?.data?.USDT}</p>
          </div>
          <div className="col-5 align-self-center text-end">
            <div className="whatsapp-icon rounded-circle" onClick={handleToContactUs}>
              <img src={contactImage} alt="contact Icon"/>
            </div>
          </div>
          <div className="col-6 mt-3">
            <div className="copy-icon text-white pe-auto">
              {userData?.referralCode}
              <img className="ms-2" src={copyImage} onClick={handleCopyClick} alt='copyIcon' />
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handleToTerms}>
              <img className="mx-auto" src={termImage} alt="Term" />
              <span className="my-2 fw-bold text-white">Terms</span>
            </div>
          </div>

          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handleToAboutUs}>
              <img className="mx-auto" src={aboutImage} alt="About Us" />
              <span className="my-2 fw-bold text-white">About us</span>
            </div>
          </div>

          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handleToCertificate}>
              <img className="mx-auto" src={certImage} alt="Certificate" />
              <span className="my-2 fw-bold">Certificate</span>
            </div>
          </div>
          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handleToWithdraw}>
              <img className="mx-auto" src={withdrawImage} alt="Withdraw" />
              <span className="my-2 fw-bold">Withdraw</span>
            </div>
          </div>
          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handelToCheckIn}>
              <img className="mx-auto" src={checkinImage} alt="check-in" />
              <span className="my-2 fw-bold">Check-In</span>
            </div>
          </div>
          <div className="col-4 mt-2">
            <div className="pt-4 card-box-pink square d-flex flex-column align-items-center rounded-4" onClick={handleToFaqs}>
              <img className="mx-auto" src={faqImage} alt="FAQ" />
              <span className="my-2 fw-bold">FAQ</span>
            </div>
          </div>
          <div className="mt-2 mb-4">
            <div className="py-3 card-box-pink rounded-4 d-flex flex-column align-items-center rounded-4" onClick={handelToEvent}>
              <img className="mx-auto mb-2" src={eventImage} alt="Event" />
              <span className="my-2 fw-bold">Latest Event</span>
            </div>
          </div>
        </div>


        <div className="col-12 d-flex align-items-center">
          <div className="col-8 ">
            <span className="text-white fs-6 fw-bold">VIP Level</span>
          </div>
          <div className="col-4 text-end pe-auto" onClick={handelToLevelDetails}>
            <span className="h6 fw-bold text-pink">View More <ArrowForwardIosIcon sx={{ fontSize: 20, color: "var(--pink)" }}/></span>
          </div>
        </div>
        <div className="mt-2 badge-section overflow-auto ">
          {dashboardData?.vipLevelList && dashboardData?.vipLevelList.map((item, index) => (
            <div className="card-box-badge me-3 px-3 py-4 rounded-4" key={index}>
              <img className="mb-4" src={item.imageUrl} alt={item.levelId} />
              <p className="fs-5 mb-4 fw-bold">{item.lvlDesc}</p>
              {/*<p*/}
              {/*    className='lightGrey'*/}
              {/*  dangerouslySetInnerHTML={{*/}
              {/*    __html: item.remark,*/}
              {/*  }}>*/}
              {/*</p>*/}
              {/*<p>{item.profitPercentage}% profit per trade</p>*/}
              {/*<p>{item.setAmount} trades/day</p>*/}
              {/*<p>{item.packagePercentage} trades/set</p>*/}

                <div className='d-flex flex-column lightGrey fs-6'>
                    <span>- {item.lvlDesc} agents receive unlimited access to all features of the workbench.</span>
                    <span>- Deposit in accordance with our renewal event {item.profitPercentage} per item.</span>
                    <span>- Better Profit ad permission</span>
                    <span>- Up to {item.setAmount} items per day can be submitted by Bronze agent</span>
                    <span>- Full access to all other Premium features</span>
                </div>
            </div>
          ))}
        </div>
        {showFAQModal && (
            <ModelFAQ onClose={closeFAQModal} />
        )}
        {showSliderModal && (
            <ModelSlider onClose={closeSliderModal} title={modalContent.title} message={modalContent.content} />
        )}
        {showModal && (
            <Model onClose={closeModal} title={modalContent.title} message={modalContent.content} />
        )}
        {showContactModal && (
            <ModelContact onClose={closeContactModal} title={modalContent.title} message={modalContent.content} />
        )}
        <Copyright_Footer/>
      </div>
      <Footer />
    </>
  );
}
